/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Partner_Validity_PeriodInputs */

const en_clients_field_partner_validity_period = /** @type {(inputs: Clients_Field_Partner_Validity_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validity (months)`)
};

const pt_br2_clients_field_partner_validity_period = /** @type {(inputs: Clients_Field_Partner_Validity_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validade (meses)`)
};

/**
* | output |
* | --- |
* | "Validity (months)" |
*
* @param {Clients_Field_Partner_Validity_PeriodInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_partner_validity_period = /** @type {((inputs?: Clients_Field_Partner_Validity_PeriodInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Partner_Validity_PeriodInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_partner_validity_period(inputs)
	return pt_br2_clients_field_partner_validity_period(inputs)
});